import { render, staticRenderFns } from "./CCSvgIcon.vue?vue&type=template&id=1c520f9b&scoped=true"
import script from "./CCSvgIcon.vue?vue&type=script&lang=js"
export * from "./CCSvgIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c520f9b",
  null
  
)

export default component.exports